import { RadiologistNote } from '@/api/model';
import { isNotEmpty } from '@/shared/util';

interface IsConsultNoteRequiredArgs {
  publishedNotes?: RadiologistNote[];
  urgencyCategory?: null | string;
}

export function isConsultNoteRequired({
  publishedNotes,
  urgencyCategory,
}: IsConsultNoteRequiredArgs): boolean {
  if (urgencyCategory !== 'IV') {
    return false;
  }

  const hasPublishedNote = publishedNotes?.some((note) => isNotEmpty(note.content)) ?? false;

  return !hasPublishedNote;
}
